import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory()({
  targets: { selectable: HTMLAnchorElement },
}) {
  select(event: MouseEvent): void {
    for (const target of this.selectableTargets) {
      if (target.ariaCurrent === "page") {
        target.ariaCurrent = "false";
      }
    }

    // Set the current link to the page
    const eventTarget = event.target as HTMLAnchorElement;
    eventTarget.ariaCurrent = "page";
  }
}
